import { fetchProducts } from '../../Listing/actions/listingActions';
import * as filterActions from './actionTypes';

const { REMOVE_FILTERS_BY_TYPE, SET_ACTIVE_FILTER_BY_TYPE } = filterActions;

export const storeAvailableFilters = filters => ({
    type: filterActions.STORE_AVAILABLE_FILTERS,
    payload: filters
});

export const storeGenderFilter = filter => ({
    type: filterActions.STORE_GENDER_FILTER,
    payload: filter
});

export const storeAgeFilter = filter => ({
    type: filterActions.STORE_AGE_FILTER,
    payload: filter
});

export const storePersonalCategory = filters => ({
    type: filterActions.STORE_PERSONAL_CATEGORY,
    payload: filters
});

export const deselectAllFilters = () => (dispatch) => {
    dispatch({
        type: filterActions.DESELECT_ALL_FILTERS
    });

    dispatch(fetchProducts());
};

/**
 * Toggle single filter
 *
 * @param {object} filter
 */
export const toggleFilter = filter => (dispatch) => {
    dispatch({
        type: filterActions.UPDATE_ACTIVE_FILTERS,
        payload: filter
    });

    dispatch(fetchProducts());
};

export const applyCurrentFilters = () => (dispatch) => {
    dispatch(fetchProducts());
};

export const addPersonalCategory = () => (dispatch) => {
    dispatch({
        type: filterActions.ADD_PERSONAL_CATEGORY
    });
};

export const removePersonalCategory = () => (dispatch) => {
    dispatch({
        type: filterActions.REMOVE_PERSONAL_CATEGORY
    });
};

/**
 * Toggle multiple filters
 *
 * @param {array} filters
 * @param {boolean} toggle
 */
export const toggleMultipleFilters = (filters, toggle) => (dispatch) => {
    dispatch({
        type: filterActions.BULK_UPDATE_ACTIVE_FILTERS,
        payload: { filters, toggle }
    });

    dispatch(fetchProducts());
};

export const removeFiltersByType = type => ({
    type: REMOVE_FILTERS_BY_TYPE,
    payload: type
});

export const setActiveFilterByType = value => (dispatch) => {
    dispatch({
        type: SET_ACTIVE_FILTER_BY_TYPE,
        payload: value
    });

    dispatch(fetchProducts());
};
